import { useState } from "react";
import styled from "@emotion/styled";
import {
  Icon,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Toolbar,
  Typography,
} from "@mui/material";
import _ from "lodash";
import {
  useGroupTablePage_GroupsQuery,
  useGroupTablePage_DeleteGroupMutation,
} from "../../../../generated/graphql";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../../../components/DeleteModal";

const Container = styled("div")`
  margin: 32px;
`;

const CToolbar = styled(Toolbar)`
  border-bottom: 1px rgba(0, 0, 0, 0.1) solid;
`;

const Title = styled(Typography)`
  flex: 1;
`;

export const GroupTablePage = () => {
  const navigate = useNavigate();
  const [deleteId, setDeleteId] = useState<string | undefined>();
  const [deleteGroup, { loading: deleteLoading }] =
    useGroupTablePage_DeleteGroupMutation();
  const { data, refetch } = useGroupTablePage_GroupsQuery();

  return (
    <Container>
      <Paper>
        <CToolbar>
          <Title>Grupos</Title>
          <IconButton onClick={() => navigate("/ravpro/groups/create")}>
            <Icon>add</Icon>
          </IconButton>
        </CToolbar>
        <Table>
          {data?.groups && data?.groups.length > 0 ? (
            <TableHead>
              <TableRow>
                <TableCell>Nome</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
          ) : null}
          <TableBody>
            {_.orderBy(data?.groups, "name").map((row) => (
              <TableRow key={row.uuid} hover>
                <TableCell>{row.name}</TableCell>
                <TableCell align="right">
                  <IconButton
                    onClick={() =>
                      navigate(`/ravpro/groups/update/${row.uuid}`)
                    }
                  >
                    <Icon>edit</Icon>
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      setDeleteId(row.uuid);
                    }}
                  >
                    <Icon>delete</Icon>
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
            {data?.groups && data.groups.length === 0 ? (
              <TableRow>
                <TableCell align="center">Nenhum registro encontrado</TableCell>
              </TableRow>
            ) : null}
          </TableBody>
        </Table>
      </Paper>
      <DeleteModal
        open={!!deleteId}
        onClose={() => setDeleteId(undefined)}
        loading={deleteLoading}
        onConfirm={async () => {
          await deleteGroup({ variables: { uuid: deleteId! } });
          setDeleteId(undefined);
          refetch();
        }}
      />
    </Container>
  );
};
